<template>
  <div class="notice-container" :class="{ 'skip-pending': !displayContent }">
    <div v-if="displayContent" class="content-box">
      <div class="notice-content">
        <h3 class="title">报名须知</h3>
        <div v-html="noticeContent"></div>
      </div>
      <div class="action-section">
        <label class="checkbox-label">
          <input type="checkbox" v-model="agreed" :disabled="hasNoticeFile && !hasAgreedInDialog" class="checkbox-input"/>
          <span @click.prevent.stop="handleReadTextClick">本人已阅读并完全了解<a v-if="hasNoticeFile" href="javascript:void(0)" @click.stop.prevent="visitFile">{{ fileData.attName }}</a></span>
        </label>
        <button class="agree-btn" :disabled="!agreed" @click="handleAgree"> 同意并报名</button>
      </div>
    </div>
    
    <!-- 文档弹窗组件 -->
    <DocumentDialog
      v-if="displayContent"
      :visible="dialogVisible"
      :document-data="fileData"
      :countdown-seconds="5"
      @cancel="handleDialogCancel"
      @submit="handleDialogSubmit"
    />
  </div>
</template>

<script>
import DocumentDialog from '@/components/DocumentDialog.vue'

export default {
  name: 'Notice',
  components: {
    DocumentDialog
  },
  data() {
    return {
      MOCK_PREFIX: process.env.VUE_APP_MOCK_PREFIX || '',
      agreed: false,
      hasAgreedInDialog: false, // 是否在弹窗中点击了"阅读并同意"
      noticeContent:'',
      fileData:{},
      dialogVisible: false,
      displayContent: false
    }
  },
  created() {
    this.getData();
  },
  computed: {
    hasNoticeFile() {
      return !!Object.keys(this.fileData || {}).length
    }
  },
  methods: {
    isRichTextEmpty(content) {
      const normalizedText = String(content || '')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;|&#160;/gi, '')
        .replace(/\u00A0/g, '')
        .replace(/[\s\u200B-\u200D\uFEFF]/g, '')
      return !normalizedText
    },
    getData() {
      this.$http.get(this.MOCK_PREFIX+'/student/pc/getNotice').then(res => {
        this.noticeContent = (res && res.content) || ''
        this.fileData = (res && res.noticeAtts && res.noticeAtts[0]) || {}
        this.hasAgreedInDialog = !this.hasNoticeFile
        const shouldSkip = this.shouldSkipNotice()
        sessionStorage.setItem('BM_NOTICE_OPTIONAL_SKIPPED', shouldSkip ? '1' : '0')
        if (shouldSkip) {
          this.$emit('next-step')
          return
        }
        this.displayContent = true
      }).catch(() => {
        sessionStorage.setItem('BM_NOTICE_OPTIONAL_SKIPPED', '0')
        this.displayContent = true
      })
    },
    shouldSkipNotice() {
      const hasContent = !this.isRichTextEmpty(this.noticeContent)
      return !hasContent && !this.hasNoticeFile
    },
    handleAgree() {
      if (this.agreed) {
        this.$emit('next-step')
      }
    },
    handleReadTextClick() {
      if (this.hasNoticeFile && !this.hasAgreedInDialog) {
        this.visitFile()
        return
      }
      this.agreed = !this.agreed
    },
    visitFile(){
      if (!this.hasNoticeFile) {
        return
      }
      this.dialogVisible = true
    },
    handleDialogCancel() {
      this.dialogVisible = false
    },
    handleDialogSubmit() {
      this.dialogVisible = false
      this.hasAgreedInDialog = true
      this.agreed = true
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-container {
  width: 100%;
  padding: 20px 0;
}

.notice-container.skip-pending {
  padding: 0;
}
.content-box {
  width: 1000px;
  margin: 0 auto;
  .notice-content {
    width: 1000px;
    min-height: 300px;
    background: #F9F9F9;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #F3F3F3;
    box-sizing: border-box;
    padding: 20px 40px;
    .title{
      font-size: 20px;
      font-weight: 600;
      color: #1A1A1A;
      margin-bottom: 20px;
      text-align: center;
    }
  }
}



.intro {
  margin-bottom: 20px;
  text-indent: 0;
}

.terms {
  margin-bottom: 30px;
}

.term-item {
  display: flex;
  margin-bottom: 20px;
  align-items: flex-start;
}

.term-number {
  font-weight: 600;
  margin-right: 8px;
  flex-shrink: 0;
}

.term-content {
  flex: 1;
  
  p {
    margin: 0;
    margin-bottom: 10px;
  }
}

.term-details {
  margin-top: 10px;
  padding-left: 0;
  
  p {
    margin: 5px 0;
  }
}

.url {
  color: #ff0000;
}

.action-section {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 12px;
  color: #1A1A1A;
  user-select: none;
  
  .checkbox-input {
    margin-right: 8px;
    width: 16px;
    height: 16px;
    cursor: pointer;
    
    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }
  }
  
  a {
    color: #4084ff;
    text-decoration: none;
    margin-left: 4px;
    transition: color 0.3s;
    
    &:hover {
      color: #1687de;
      text-decoration: underline;
    }
  }
}

.agree-btn {
  width: 330px;
  height: 40px;
  background: linear-gradient( 90deg, #1687DE 0%, #4084FF 100%);
  border-radius: 10px 10px 10px 10px;
  color: #fff;
  border: none;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: 500;

  &:hover:not(:disabled) {
    opacity: 0.9;
    transform: translateY(-1px);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    opacity: 0.6;
  }
}
</style>